import { AppModule } from './ModuleManager';
import { disableConsoleInProduction } from '@/lib/disableConsole';

/**
 * 控制台禁用模块
 * 在生产环境中禁用浏览器控制台输出
 */
export class DisableConsoleModule implements AppModule {
  name = 'DisableConsole';
  priority = 1; // 最高优先级,最先执行

  init(): void {
    if (typeof window === 'undefined') return;

    disableConsoleInProduction();
    console.log('[DisableConsoleModule] Initialized');
  }

  destroy(): void {
    // 控制台禁用无需清理
  }
}
